/**
 * `/r/:code` — the dashboard entered through someone's referral link.
 *
 * The code reaches `Dashboard` as a prop rather than being written to storage
 * here: the dashboard decides whether to adopt it, and doing it in two places
 * would let a link silently overwrite a code the user already committed to.
 */
import { useParams } from "react-router-dom";

import { Dashboard } from "@/components/Dashboard/Dashboard";

export default function ReferralPage() {
  const { code } = useParams<{ code: string }>();

  return <Dashboard code={code} />;
}
